<div class="icon-container" style="padding:2px;">
    <div class="menu-icon-dash" id="top" style="top: 6px;"></div>
    <div class="menu-icon-dash" id="middle" style="top: 13px;"></div>
    <div class="menu-icon-dash" id="bottom" style="top: 20px;"></div>
</div>